// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__IPA9Z","btn_disabled":"Button_btn_disabled__5Otoo"};